import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { GET_TRANSFER_APPROVER_ACTIONS_DATA, GET_TRANSFER_ITEM_AND_ORDER_LEVEL_APPROVAL} from 'Store/Transfer/TransferApproval/TransferApprovalType';
import { setAssetApprovalData, setIsTransferItemAndOrderLevelApproval, setTransferApproverActionData } from 'Store/Transfer/TransferApproval/TransferApprovalAction';
import TransferApprovalApiService from './TransferApprovalApiService';
import { apiMethod, apiType, API_URL } from 'utils';
import { IPayload } from 'Model/IPayload';

function* transferItemAndOrderLevelApprovalSaga(req: any): any {
    try {
        yield put(globalLoaderText("Updating order...."));

        let payloadData : IPayload = {                
            apiMethod : apiMethod.POST,
            apiType : apiType.OrderManagement,
            endpoint : `orderapproval`,
            payload : req?.val
        }
        const response = yield call(TransferApprovalApiService.post, 
            API_URL.PostWebApp, payloadData);
        if(response) {
            yield put(setIsTransferItemAndOrderLevelApproval(response?.isSuccess))
            yield put(setAssetApprovalData(response))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(setIsTransferItemAndOrderLevelApproval(false))
        yield put(globalLoaderText(""));
    }
}

function* getApproverActionDataSaga(): any {
    try {
       // const response = yield call(api.callOrderGet, `masterdata/dropdown/approveractions`);
        const response = [
            { disabled: false, group: null, selected: false, value: '1', text: 'Approve', key:"Approve" },
            { disabled: false, group: null, selected: false, value: '2', text: 'Reject', key:"Reject" },
            { disabled: false, group: null, selected: false, value: '3', text: 'Request More Info', key:"Request More Info" },
        ]
        yield put(setTransferApproverActionData(response))
    } catch (error) {
        yield put(setTransferApproverActionData([]))
    }
}


function* watchApproval() {
    yield takeEvery(GET_TRANSFER_ITEM_AND_ORDER_LEVEL_APPROVAL, transferItemAndOrderLevelApprovalSaga);
    yield takeEvery(GET_TRANSFER_APPROVER_ACTIONS_DATA, getApproverActionDataSaga);
}

export default function* combinedSaga() {
    yield all([
        watchApproval()
    ])
  }
